import Typography from '@mui/material/Typography';
import { useCallback, useMemo, useState } from 'react';
import { Controller, useForm } from 'react-hook-form';
import { yupResolver } from '@hookform/resolvers/yup';
import * as yup from 'yup';
import SearchOutlinedIcon from '@mui/icons-material/SearchOutlined';
import { useCompanyCore } from '../../../../core/modules/company';
import { Button, FormControl, InputLabel, Select, MenuItem, TextField } from '@mui/material';
import { useBusinessCore } from '../../../../core/modules/business';
import PrintIcon from '@mui/icons-material/Print';

interface SearchFormData {
  provider_id: number;
  container_code: string;
  origin_container_code: string;
  reception_code: string;
}

const schema = yup.object().shape({
  provider_id: yup.number().required('Campo requerido'),
  container_code: yup.string().required('Campo requerido'),
  origin_container_code: yup.string().required('Campo requerido'),
  reception_code: yup.string().required('Campo requerido'),
});

const Header = () => {
  const { companyId } = useCompanyCore();
  const { businesses } = useBusinessCore();

  const { control, formState, handleSubmit } = useForm<SearchFormData>({
    mode: 'onChange',
    resolver: yupResolver(schema),
  });
  const { isValid } = formState;

  const [loading, setLoading] = useState(false);
  const [labelType, setLabelType] = useState<'small' | 'large'>('large');

  const onSubmit = useCallback(
    (values: unknown) => {
      if (companyId) {
        setLoading(true);
       
      }
    },
    [companyId]
  );

  const providers = useMemo(() => {
    return businesses.filter((business) => business.is_provider);
  }, [businesses]);

  return (
    <div className="p-24 sm:p-32 w-full border-b-1 bg-white header-components">
      <div className="flex flex-col sm:flex-row justify-between items-center gap-4">
        <div className="flex flex-col items-center sm:items-start">
          <Typography className="text-24 md:text-32 font-extrabold tracking-tight leading-none">
            Consulta Contenedores
          </Typography>
        </div>
      </div>
      <div className="flex items-center gap-8 mb-12">
        <FormControl size="small">
          <InputLabel id="label-type-select">Tipo de Etiqueta</InputLabel>
          <Select
            labelId="label-type-select"
            value={labelType}
            label="Tipo de Etiqueta"
            onChange={e => setLabelType(e.target.value as 'small' | 'large')}
            sx={{ minWidth: 180 }}
          >
            <MenuItem value="small">Etiqueta pequeña</MenuItem>
            <MenuItem value="large">Etiqueta grande</MenuItem>
          </Select>
        </FormControl>
        <Button
          variant="contained"
          color="primary"
          startIcon={<PrintIcon />}
          disabled={loading}
        >
          Imprimir Etiqueta
        </Button>
      </div>
      <form noValidate onSubmit={handleSubmit(onSubmit)} className="flex w-full mt-20">
        <div className="flex w-full px-20">
          <div className="w-full">
            <Controller
              name="provider_id"
              control={control}
              render={({ field }) => (
                <FormControl
                  className="max-w-[320px]"
                  size='small'
                  required
                  fullWidth
                >
                  <InputLabel id="provider-label">
                    Proveedor
                  </InputLabel>
                  <Select
                    {...field}
                    labelId="provider-label"
                    label="Proveedor"
                    required
                    size='small'
                    disabled={loading}
                  >
                    <MenuItem value={''}>Seleccionar</MenuItem>
                    {providers.map((provider) => (
                      <MenuItem key={provider.id} value={provider.id}>
                        {provider.name}
                      </MenuItem>
                    ))}
                  </Select>
                </FormControl>
              )}
            />
          </div>
          <div className="w-full">
            <Controller
              name="origin_container_code"
              control={control}
              render={({ field }) => (
                <TextField
                  {...field}
                  label="Contenedor origen"
                  size='small'
                  variant="outlined"
                  required
                  fullWidth
                />
              )}
            />
          </div>
          <div className="w-full">
            <Controller
              name="container_code"
              control={control}
              render={({ field }) => (
                <TextField
                  {...field}
                  label="Contenedor destino"
                  size='small'                  
                  variant="outlined"
                  required
                  fullWidth
                />
              )}
            />
          </div>
          <div className="w-full">
            <Controller
              name="reception_code"
              control={control}
              render={({ field }) => (
                <TextField
                  {...field}
                  label="N recepción"
                  size='small'
                  variant="outlined"
                  required
                  fullWidth
                />
              )}
            />
          </div>
        </div>
        <Button
          variant="contained"
          color="secondary"
          className="mx-10"
          type="submit"
          disabled={!isValid || loading}
        >
          <SearchOutlinedIcon />
          <span className="mx-8">Buscar</span>
        </Button>
      </form>
    </div>
  );
};

export default Header;
